export function formatDate(data){
    
    let dataF = new Date(data).toLocaleDateString();

    return dataF;
}